module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Sales Execution Form")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.ffExoprtDetail.allModuleId != ''
  ) ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.showModalLoc
    }
  }, [_vm._v("Change Location")]) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.allModuleId != '' &&
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.newContainerFlow == '1'
  ) ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.showModalCon
    }
  }, [_vm._v("Change Request Panel")]) : _vm._e(), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1)], 1), _vm._v(" "), _c('div', [(_vm.ffExoprtDetail.clientIsActive == '2') ? _c('b-button', {
    staticStyle: {
      "margin-left": "650px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.updateClient
    }
  }, [_vm._v("Convert To Client")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.ffExoprtDetail.allModuleId != '') ? _c('h5', {
    staticClass: "mt-2 error"
  }, [_vm._v("\n              JOB TYPE : " + _vm._s(_vm.ShowJOB) + " / Assignment No :\n              " + _vm._s(_vm.ffExoprtDetail.mainSalesSeries) + "\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.ffExoprtDetail.allModuleId == '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1),
        "disabled": segmentNameArray.isDisabled
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.ffExoprtDetail.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffExoprtDetail.jobType, index, $$v)
        },
        expression: "ffExoprtDetail.jobType[index]"
      }
    }), _vm._v(" "), _c('span', {
      style: (segmentNameArray.isDisabled == true ?
        'color:white;margin-top:17px' :
        'color:black;margin-top:17px')
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "validBookingNo"
    }
  }, [_vm._v("\n                " + _vm._s( // ffExoprtDetail.transportType == "Import" ? " BL No." : " Booking No."
    (_vm.ffExoprtDetail.transportType == 'Export' || _vm.ffExoprtDetail.transportType == 'Import' || _vm.ffExoprtDetail.transportType == 'IMPORT') ? " BL No." : " Booking No.") + "\n              ")]), _vm._v(" "), (
    _vm.newJobType.indexOf('FF') >= 0 &&
    (_vm.ffExoprtDetail.transportType == 'Export' || _vm.ffExoprtDetail.transportType == 'Import' || _vm.ffExoprtDetail.transportType == 'IMPORT') &&
    _vm.ffExoprtDetail.shipmentType == 1 &&
    _vm.ffExoprtDetail.containerInfo == 'fcl'
  ) ? _c('multi-select', {
    attrs: {
      "options": _vm.ConsoleBookingList,
      "selected-options": _vm.items,
      "placeholder": "Select Booking Number",
      "multiple": true
    },
    on: {
      "select": _vm.SelectmultiConsoleBooking
    },
    model: {
      value: (_vm.ffExoprtDetail.validmultiBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "validmultiBookingNo", $$v)
      },
      expression: "ffExoprtDetail.validmultiBookingNo"
    }
  }) : _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "validBookingNo",
      "name": "validBookingNo"
    },
    on: {
      "input": function($event) {
        _vm.fetchExistExec();
        _vm.checkFFCONBookingNo();
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "validBookingNo", $$v)
      },
      expression: "ffExoprtDetail.validBookingNo"
    }
  }), _vm._v(" "), (
    _vm.ConsoleBookingList.length <= 0 &&
    _vm.newJobType.indexOf('FF') >= 0 &&
    (_vm.ffExoprtDetail.transportType == 'Export' || _vm.ffExoprtDetail.transportType == 'Import' || _vm.ffExoprtDetail.transportType == 'IMPORT')
    // ffExoprtDetail.transportType == 'Export' 
    &&
    _vm.ffExoprtDetail.shipmentType == 1 &&
    _vm.ffExoprtDetail.containerInfo == 'fcl'
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ConsoleBookingListMSG))]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.timmerMsg) + " ")]), _vm._v(" "), (
    _vm.newJobType.indexOf('FF') >= 0 &&
    _vm.ffExoprtDetail.transportType == 'Export' &&
    _vm.ffExoprtDetail.shipmentType == 1 &&
    _vm.ffExoprtDetail.containerInfo == 'fcl' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
    _vm.$sessionsStorage.get('designation') == 'Admin'
  ) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.checkAllCBBTN();
        _vm.getConsoleBooking();
      }
    },
    model: {
      value: (_vm.checkAllCBVal),
      callback: function($$v) {
        _vm.checkAllCBVal = $$v
      },
      expression: "checkAllCBVal"
    }
  }, [_vm._v(_vm._s(_vm.checkAllCBVal ? "Selected" : "Un-Selected"))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(
    (_vm.ffExoprtDetail.allModuleId != '' &&
      _vm.$sessionsStorage.get('designation') == 'Admin' &&
      _vm.ffExoprtDetail.engJobType.indexOf('FF') >= 0 &&
      _vm.ffExoprtDetail.transportType == 'Export' &&
      _vm.ffExoprtDetail.shipmentType == 1 &&
      _vm.ffExoprtDetail.containerInfo == 'fcl' &&
      _vm.checkCBNoButton == 1) ||
    (_vm.ffExoprtDetail.isConsolidation == 1 && _vm.checkCBNoButton == 1)
  ) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.updateBookingNo
    }
  }, [_vm._v("Update Booking No")]) : _vm._e()], 1)])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.showSameBookingError) ? _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.showModalExist
    }
  }, [_vm._v("Show Executions")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "error mt-2"
  }, [_c('h5', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.showSameBookingError))]), _vm._v(" "), (_vm.showSameBookingError) ? _c('div', [_c('b-form-checkbox', {
    staticStyle: {
      "padding-top": "none !important"
    },
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.checkstatus),
      callback: function($$v) {
        _vm.checkstatus = $$v
      },
      expression: "checkstatus"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n                continue with mentioned\n                " + _vm._s( // ffExoprtDetail.transportType == "Import" ? "BL No." : "Booking No."
    (_vm.ffExoprtDetail.transportType == 'Export' || _vm.ffExoprtDetail.transportType == 'Import' || _vm.ffExoprtDetail.transportType == 'IMPORT') ? " BL No." : " Booking No.") + "\n              ")])], 1) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Client Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.clientType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "clientType", $$v)
      },
      expression: "ffExoprtDetail.clientType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.clientType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.clientTypeError) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Shipping Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shipmentType", $$v)
      },
      expression: "ffExoprtDetail.shipmentType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shipmentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.shipmentTypeError) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Export / Import")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.transportType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transportType", $$v)
      },
      expression: "ffExoprtDetail.transportType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.transportType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.transportTypeError) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.clientType != '2') ? _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "clientId", $$v)
      },
      expression: "ffExoprtDetail.clientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.clientIdError) + "\n              ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.clientType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientName",
      "name": "newClientName",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientName", $$v)
      },
      expression: "ffExoprtDetail.newClientName"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.newClientNameError) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Email")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientEmail",
      "name": "newClientEmail",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientEmail),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientEmail", $$v)
      },
      expression: "ffExoprtDetail.newClientEmail"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientEmail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.newClientEmailError) + "\n              ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.clientType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Contact No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientPhoneNumber",
      "name": "newClientPhoneNumber",
      "type": "number",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientPhoneNumber", $$v)
      },
      expression: "ffExoprtDetail.newClientPhoneNumber"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientPhoneNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.newClientPhoneNumberError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Client Address")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "id": "newClientAddress",
      "name": "newClientAddress",
      "type": "number",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientAddress),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientAddress", $$v)
      },
      expression: "ffExoprtDetail.newClientAddress"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.newClientAddressError) + "\n              ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(
    _vm.ffExoprtDetail.pickupLocationId != '' &&
    _vm.ffExoprtDetail.pickupLocationId != null &&
    _vm.ffExoprtDetail.pickupLocationId != 0
  ) ? _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAlllocationHandover,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location",
      "isDisabled": true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "pickupLocationId", $$v)
      },
      expression: "ffExoprtDetail.pickupLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.pickupLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pickupLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.handoverLocationId != '' &&
    _vm.ffExoprtDetail.handoverLocationId != null &&
    _vm.ffExoprtDetail.handoverLocationId != 0
  ) ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoHandoverLocation"
    }
  }, [_vm._v("Handover Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getAlllocationHandover,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location",
      "isDisabled": true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.handoverLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "handoverLocationId", $$v)
      },
      expression: "ffExoprtDetail.handoverLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.handoverLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.handoverLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.handoverLocationId != '' &&
    _vm.ffExoprtDetail.handoverLocationId != null &&
    _vm.ffExoprtDetail.handoverLocationId != 0
  ) ? _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoStuffingLocation"
    }
  }, [_vm._v("Factory Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disableFactory == true ? true : false,
      "list": _vm.allLocationListFactory,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": _vm.allLocationList.length > 0 ?
        'Select Factory Location' :
        'No Factory'
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingLocationId", $$v)
      },
      expression: "ffExoprtDetail.stuffingLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.stuffingLocationIdError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(
    _vm.ffExoprtDetail.handoverLocationId != '' &&
    _vm.ffExoprtDetail.handoverLocationId != null &&
    _vm.ffExoprtDetail.handoverLocationId != 0
  ) ? _c('md-layout', [(_vm.ffExoprtDetail.allModuleId == '' && _vm.disableFactory == false) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("Add Factory")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(
    _vm.ffExoprtDetail.tptType != '' &&
    _vm.ffExoprtDetail.tptType != null &&
    _vm.ffExoprtDetail.tptType != 0
  ) ? _c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("TPT Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select TPT Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.tptType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "tptType", $$v)
      },
      expression: "ffExoprtDetail.tptType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.tptType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.tptType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transporterName",
      "name": "transporterName",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.transporterName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transporterName", $$v)
      },
      expression: "ffExoprtDetail.transporterName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.tptType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.onAccountOf != '' &&
    _vm.ffExoprtDetail.onAccountOf != null &&
    _vm.ffExoprtDetail.onAccountOf != 0
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("ON ACCOUNT OF")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "onAccountOf",
      "name": "onAccountOf"
    },
    model: {
      value: (_vm.ffExoprtDetail.onAccountOf),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "onAccountOf", $$v)
      },
      expression: "ffExoprtDetail.onAccountOf"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.multiContainer), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      staticClass: "pr-2",
      attrs: {
        "md-flex": "50"
      }
    }, [_c('label', [_vm._v(_vm._s(index + 1) + " - Container Type *")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": ""
      },
      model: {
        value: (_vm.multiContainer[index].containerType),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "containerType", $$v)
        },
        expression: "multiContainer[index].containerType"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      staticClass: "pl-2",
      attrs: {
        "md-flex": "50"
      }
    }, [_c('label', [_vm._v("No. of Container *")]), _vm._v(" "), _c('b-input', {
      attrs: {
        "type": "text",
        "id": "freightNoOfContainers",
        "name": "freightNoOfContainers"
      },
      model: {
        value: (_vm.multiContainer[index].freghtContainersNo),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "freghtContainersNo", $$v)
        },
        expression: "multiContainer[index].freghtContainersNo"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "5px"
      }
    }, [(_vm.multiContainer.length > 1 && _vm.ffExoprtDetail.allModuleId == '') ? _c('b-button', {
      staticClass: "mb-2",
      staticStyle: {
        "margin-top": "40px"
      },
      attrs: {
        "size": "sm",
        "variant": "light"
      },
      on: {
        "click": function($event) {
          _vm.removeContainerType(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]) : _vm._e()], 1)])], 1)
  }), _vm._v(" "), _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Activity Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.containerInfoError) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Estimated Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.estimatedDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "estimatedDate", $$v)
      },
      expression: "ffExoprtDetail.estimatedDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getImporterExpo,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name",
      "isDisabled": _vm.ffExoprtDetail.clientType != '3' ? true : false
    },
    model: {
      value: (_vm.ffExoprtDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "importerClientId", $$v)
      },
      expression: "ffExoprtDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.importerClientIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getImporterExpo,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name",
      "isDisabled": _vm.ffExoprtDetail.clientType != '3' ? true : false
    },
    model: {
      value: (_vm.ffExoprtDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "exporterClientId", $$v)
      },
      expression: "ffExoprtDetail.exporterClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.exporterClientIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [(_vm.openImpoInput == true) ? _c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]) : _vm._e(), _vm._v(" "), (_vm.openImpoInput == true) ? _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "otherImpoName",
      "name": "otherImpoName"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherImpoName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherImpoName", $$v)
      },
      expression: "ffExoprtDetail.otherImpoName"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.openExpoInput == true) ? _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "otherExpoName",
      "name": "otherExpoName"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherExpoName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherExpoName", $$v)
      },
      expression: "ffExoprtDetail.otherExpoName"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("Stuffing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeList,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Stuffing Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingType", $$v)
      },
      expression: "ffExoprtDetail.stuffingType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.stuffingTypeError) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.multipleContainerTypeId == '15' &&
    _vm.ffExoprtDetail.transportType == 'Export' &&
    _vm.newJobType ?
    _vm.newJobType.indexOf('TPT') :
    _vm.ffExoprtDetail.engJobType.indexOf('TPT') >= 0 &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('model-list-select', {
    attrs: {
      "list": _vm.getColoaderNameList,
      "option-value": "agntColoaderId",
      "option-text": "coLoaderName",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }) : _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.shippingIdError) + "\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.IcdPOrtList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PORlocationIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Load Port Name (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name",
      "isDisabled": _vm.ShowJOB.split(',').includes('FF') ? true : false,
      "isError": _vm.ffExoprtDetail.portType != 'Icd' ? true : false
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_India' :
          'Sea_Port_NonIndia',
          'PortLoadList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_India' :
          'Sea_Port_NonIndia',
          'PortLoadList'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.LPlocationIdError) + "\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD",
      "isDisabled": _vm.newJobType.indexOf('FF') >= 0 || _vm.ffExoprtDetail.allModuleId ?
        true :
        false
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Sea_Port_India',
          'getPortDischargeList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'getPortDischargeList'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PODLocationIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery (Freight)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD",
      "isDisabled": _vm.newJobType.indexOf('FF') >= 0 || _vm.ffExoprtDetail.allModuleId ?
        true :
        false
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceLocationId", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.finalPlaceLocationIdError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryMode", $$v)
      },
      expression: "ffExoprtDetail.deliveryMode"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryTerms", $$v)
      },
      expression: "ffExoprtDetail.deliveryTerms"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Airport of Departure")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AirIcdPOrtList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport Departure",
      "isDisabled": true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirIcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.airportDeparture),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airportDeparture", $$v)
      },
      expression: "ffExoprtDetail.airportDeparture"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.airportDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.airportDepartureError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Airport of Destination")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AirPortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Destination",
      "isDisabled": true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirPortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.airportDestination),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airportDestination", $$v)
      },
      expression: "ffExoprtDetail.airportDestination"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.airportDestination) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.airportDestinationError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Airline")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.airLineList,
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Airline"
    },
    model: {
      value: (_vm.ffExoprtDetail.airlineId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airlineId", $$v)
      },
      expression: "ffExoprtDetail.airlineId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("CoLoader Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.getColoaderNameList,
      "option-value": "agntColoaderId",
      "option-text": "coLoaderName",
      "placeholder": "Select Coloader Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.coLoaderId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "coLoaderId", $$v)
      },
      expression: "ffExoprtDetail.coLoaderId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '2' ||
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "noOfPkg"
    }
  }, [_vm._v("No. of Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "noOfPkg",
      "name": "noOfPkg",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.noOfPkg),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "noOfPkg", $$v)
      },
      expression: "ffExoprtDetail.noOfPkg"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Cargo Received At")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cargoReceivedList,
      "option-value": "val",
      "isDisabled": true,
      "option-text": "type",
      "placeholder": "Select Cargo Received"
    },
    model: {
      value: (_vm.ffExoprtDetail.cargoReceived),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "cargoReceived", $$v)
      },
      expression: "ffExoprtDetail.cargoReceived"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.cargoReceived) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.cargoReceivedError))]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Destination Delievery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.destinationDelieveryList,
      "option-value": "val",
      "option-text": "type",
      "isDisabled": true,
      "placeholder": "Select Destination"
    },
    model: {
      value: (_vm.ffExoprtDetail.destinationModeAir),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "destinationModeAir", $$v)
      },
      expression: "ffExoprtDetail.destinationModeAir"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.destinationModeAir) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.destinationModeAirError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.destinationModeAir == '2') ? _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Destination",
      "isDisabled": true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.doorDestinationfpod),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "doorDestinationfpod", $$v)
      },
      expression: "ffExoprtDetail.doorDestinationfpod"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccType", $$v)
      },
      expression: "ffExoprtDetail.ccType"
    }
  })], 1), _vm._v(" "), (_vm.ffExoprtDetail.ccType == '2') ? _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha",
      "disabled": ""
    },
    model: {
      value: (_vm.ffExoprtDetail.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccCha", $$v)
      },
      expression: "ffExoprtDetail.ccCha"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "otherComodity"
    }
  }, [_vm._v("Commodity Details")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityType", $$v)
      },
      expression: "ffExoprtDetail.commodityType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.commodityType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.commodityTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ffExoprtDetail.remark),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "remark", $$v)
      },
      expression: "ffExoprtDetail.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Hazardous') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.ffExoprtDetail.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "IMDGClass", $$v)
      },
      expression: "ffExoprtDetail.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.ffExoprtDetail.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "UNNumber", $$v)
      },
      expression: "ffExoprtDetail.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.ffExoprtDetail.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "packingCode", $$v)
      },
      expression: "ffExoprtDetail.packingCode"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Reefer') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.ffExoprtDetail.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "temperatureRequired", $$v)
      },
      expression: "ffExoprtDetail.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Others') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.ffExoprtDetail.commodityType == 'Others') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.allModuleIdNew == '' || _vm.allModuleIdNew == null) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.allModuleId == '') ? _c('b-button', {
    staticClass: "mt-4 smbutnWidth",
    attrs: {
      "disabled": (_vm.checkstatus == '0' && _vm.showSameBookingError) ||
        !this.ffExoprtDetail.validBookingNo ?
        true :
        false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addFFExport
    }
  }, [_vm._v("Save & Send To Execution")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExoprtDetail.SalesExecutionCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffExoprtDetail.SalesExecutionCreated))])]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal-exist",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "lg",
      "ok-only": "",
      "title": ""
    }
  }, [_c('h5', {
    staticClass: "error mt-2"
  }, [_vm._v("\n        Existing Execution with\n        " + _vm._s(_vm.ffExoprtDetail.transportType == "Import" ? " BL No. " : " Booking No. ") + "\n        " + _vm._s(_vm.ffExoprtDetail.validBookingNo) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "d-block text-center mt-2"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Execution No.")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allExistingData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mainSalesSeries))])])
  }))])])])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("Fileld Marked with * are mandatory..!")]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v(" Factory Title-Location ( e.g : Pridel Pvt Ltd-Delhi ) * ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "factoryTitle",
      "id": "factoryTitle"
    },
    model: {
      value: (_vm.factoryModal.factoryTitle),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "factoryTitle", $$v)
      },
      expression: "factoryModal.factoryTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Address (Area/Locality,District,City,State,Country)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "factoryAddress1",
      "id": "factoryAddress1"
    },
    model: {
      value: (_vm.factoryModal.factoryAddress1),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "factoryAddress1", $$v)
      },
      expression: "factoryModal.factoryAddress1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchLatLog
    }
  }, [_vm._v("Get Lat/Long")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Latitude *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.factoryModal.latitude),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "latitude", $$v)
      },
      expression: "factoryModal.latitude"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Longitude *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.factoryModal.longitude),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "longitude", $$v)
      },
      expression: "factoryModal.longitude"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("GSTIN No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "GSTIN1",
      "id": "GSTIN1"
    },
    model: {
      value: (_vm.factoryModal.GSTIN1),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "GSTIN1", $$v)
      },
      expression: "factoryModal.GSTIN1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "error mt-3"
  }, [_c('span', {
    staticClass: "error mt-3"
  }, [_vm._v(_vm._s(_vm.showFactLocError))])])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "success",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.addClient('')
      }
    }
  }, [_vm._v("Add Factory")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal-con",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": "Manage Assignment Containers"
    }
  }, [_c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "id": "radio-group-2",
      "name": "radio-sub-component"
    },
    on: {
      "change": _vm.changeOnRadio
    },
    model: {
      value: (_vm.actionType),
      callback: function($$v) {
        _vm.actionType = $$v
      },
      expression: "actionType"
    }
  }, [(
    (_vm.ffExoprtDetail.engJobType.indexOf('FF') >= 0 ||
      _vm.ffExoprtDetail.engJobType.indexOf('CC') >= 0 ||
      _vm.ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
    (_vm.ffExoprtDetail.transportType == 'Export' ||
      _vm.ffExoprtDetail.transportType == 'Import')
  ) ? _c('b', [(
    _vm.ffExoprtDetail.transportType == 'Export' ||
    _vm.ffExoprtDetail.transportType == 'Import'
  ) ? _c('b-form-radio', {
    attrs: {
      "size": "lg",
      "value": "SPLIT"
    }
  }, [_vm._v("Move Container & Create New Assignment (Split)")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    (_vm.ffExoprtDetail.engJobType.indexOf('FF') >= 0 ||
      _vm.ffExoprtDetail.engJobType.indexOf('CC') >= 0 ||
      _vm.ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
    (_vm.ffExoprtDetail.transportType == 'Export' ||
      _vm.ffExoprtDetail.transportType == 'Import')
  ) ? _c('b', [(
    _vm.ffExoprtDetail.transportType == 'Export' ||
    _vm.ffExoprtDetail.transportType == 'Import'
  ) ? _c('b-form-radio', {
    attrs: {
      "size": "lg",
      "value": "MERGE"
    }
  }, [_vm._v("Move Containers to Existing Assignment(Merge)")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "size": "lg",
      "value": "REMOVE"
    }
  }, [_vm._v("Remove Assignment Containers")]), _vm._v(" "), (
    (_vm.ffExoprtDetail.engJobType.indexOf('FF') >= 0 ||
      _vm.ffExoprtDetail.engJobType.indexOf('CC') >= 0 ||
      _vm.ffExoprtDetail.engJobType.indexOf('TPT') >= 0) &&
    (_vm.ffExoprtDetail.transportType == 'Export' ||
      _vm.ffExoprtDetail.transportType == 'Import')
  ) ? _c('b-form-radio', {
    attrs: {
      "size": "lg",
      "value": "MOVE"
    }
  }, [_vm._v("Move Containers(Location Change)")]) : _vm._e(), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "size": "lg",
      "value": "CHANGE"
    }
  }, [_vm._v("Change Service Request")])], 1)], 1), _vm._v(" "), (_vm.actionType == 'MERGE') ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("\n        Note : 1- Container Can be merged to only assignments in which selected\n        container Types are available.\n        "), _c('br'), _vm._v("             2-\n        Selected Container will be removed from this Assignment and will be added to\n        selected Assignment.\n        "), _c('br'), _vm._v("             3-For\n        TPT Refer Current Assignment.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.actionType == 'SPLIT') ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("\n        Note : 1- A new assignment will be created for selected containers .\n        "), _c('br'), _vm._v("             2-\n        It will fall only in FF Export Module..!\n        "), _c('br'), _vm._v("             3-\n        For TPT & CC Refer Current Assignment.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.actionType == 'REMOVE') ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("\n        Note : 1- Selected Container Will be Removed. .\n        "), _c('br'), _vm._v("             2-\n        Container can be removed only if container number is not added\n      ")]) : _vm._e(), _vm._v(" "), (_vm.actionType != 'CHANGE') ? _c('div', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container No")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("--")])]), _vm._v(" "), _vm._l((_vm.containerDetails), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "width": "20px"
      },
      attrs: {
        "bgcolor": "whiteSmoke",
        "scope": "row"
      }
    }, [(itm.isSplitedOrMerged == '0') ? _c('b-form-checkbox', {
      staticClass: "ml-4",
      staticStyle: {
        "padding": "0px !important",
        "line-height": "0px !important",
        "height": "0px !important"
      },
      attrs: {
        "size": "lg",
        "disabled": itm.isSplitedOrMerged != '0' ||
          (_vm.actionType == 'REMOVE' && itm.containerNo) ||
          (_vm.actionType == 'MERGE' && !itm.containerNo) ||
          (_vm.actionType == 'SPLIT' && !itm.containerNo) ||
          (_vm.actionType == 'MOVE' && !itm.containerNo) ?
          true :
          false,
        "value": itm.uniqueContainerId,
        "unchecked-value": "0"
      },
      on: {
        "change": function($event) {
          _vm.checkNewJobType(itm)
        }
      },
      model: {
        value: (_vm.singleSelectContainer),
        callback: function($$v) {
          _vm.singleSelectContainer = $$v
        },
        expression: "singleSelectContainer"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerNo))]), _vm._v(" "), _c('td', [(itm.splitedToOrMergedToAssigNo) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                  Container Moved From :" + _vm._s(itm.fromSplitMergeAssignNo) + " to :\n                  " + _vm._s(itm.splitedToOrMergedToAssigNo) + " (\n                  "), (itm.isSplitedOrMergedNew == 1) ? _c('b', [_vm._v("Splited")]) : (itm.isSplitedOrMergedNew == 2) ? _c('b', [_vm._v("Merged")]) : (itm.isSplitedOrMergedNew == 3) ? _c('b', [_vm._v("Moved")]) : _vm._e(), _vm._v("\n                  ) Updated Date(" + _vm._s(itm.split_merge_date_time) + ")\n                ")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), (_vm.actionType == 'MERGE' || _vm.actionType == 'MOVE') ? _c('div', [_c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Merge Assignment No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.validExecution,
      "id": "clientName",
      "option-value": "allModuleId",
      "option-text": "mainSalesSeries",
      "placeholder": "Select Assignment"
    },
    on: {
      "input": _vm.getSalesSeries
    },
    model: {
      value: (_vm.ffExoprtDetail.mergeToAssignmentId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "mergeToAssignmentId", $$v)
      },
      expression: "ffExoprtDetail.mergeToAssignmentId"
    }
  })], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.actionType == 'CHANGE') ? _c('div', [_c('hr'), _vm._v(" "), _c('h6', [_vm._v("Select JOB to add")]), _vm._v(" "), _c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-2",
      "name": "flavour-2"
    },
    model: {
      value: (_vm.ffExoprtDetail.changedRequestJobType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "changedRequestJobType", $$v)
      },
      expression: "ffExoprtDetail.changedRequestJobType"
    }
  }, _vm._l((_vm.jobTypeFromEnquiry), function(item, indx) {
    return _c('b-form-checkbox', {
      key: indx,
      attrs: {
        "disabled": _vm.ShowJOB.includes(item) ? true : false,
        "value": item
      },
      on: {
        "change": function($event) {
          _vm.checkNewJobType(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModalCon
    }
  }, [_vm._v("Close & Cancel")]), _vm._v(" "), (
    ((_vm.actionType == 'MERGE' || _vm.actionType == 'MOVE') &&
      _vm.ffExoprtDetail.mergeToAssignmentId != '' &&
      _vm.singleSelectContainer.length > 0) ||
    ((_vm.actionType == 'CHANGE' ||
        _vm.actionType == 'SPLIT' ||
        _vm.actionType == 'REMOVE') &&
      _vm.singleSelectContainer.length > 0) ||
    _vm.actionType == 'CHANGE'
  ) ? _c('b-button', {
    staticClass: "mt-4 pull-right",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.mergeSplitAssignmentConfirm
    }
  }, [_vm._v(_vm._s(_vm.actionType))]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": "Console Booking UNRELEASED Approval Request"
    },
    model: {
      value: (_vm.showCBApprovalModal),
      callback: function($$v) {
        _vm.showCBApprovalModal = $$v
      },
      expression: "showCBApprovalModal"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('p', [_vm._v("\n          Console Booking No:\n          "), _c('strong', [_vm._v(_vm._s(_vm.ffExoprtDetail.validBookingNo || '-'))]), _c('br'), _vm._v(" "), (_vm.ffExoprtDetail.mainSalesSeries) ? _c('span', [_vm._v("\n          Assignment No:\n          "), _c('strong', [_vm._v(_vm._s(_vm.ffExoprtDetail.mainSalesSeries || '-'))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v("\n          Days Delayed:\n          "), _c('strong', [_vm._v(_vm._s(_vm.diffInDays || '-'))]), _c('br'), _vm._v("\n          Release Date:\n          "), _c('strong', [_vm._v(_vm._s(_vm.bookingDetails.ReleaseDate || '-'))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bookingDetails.AppovalReleaseDate) ? _c('span', [_vm._v("\n            Approval Date:\n            "), _c('strong', [_vm._v(_vm._s(_vm.bookingDetails.AppovalReleaseDate || '-'))])]) : _vm._e()]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Delay Reason *"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('model-list-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "list": _vm.cbDelayReasonOptions.filter(function (o) { return o.value !== ''; }),
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select delay reason"
    },
    on: {
      "input": function($event) {
        _vm.cbApproval.delay_reason_error = ''
      }
    },
    model: {
      value: (_vm.cbApproval.delay_reason),
      callback: function($$v) {
        _vm.$set(_vm.cbApproval, "delay_reason", $$v)
      },
      expression: "cbApproval.delay_reason"
    }
  }), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "variant": "outline-primary",
      "size": "sm",
      "title": "Add new delay reason"
    },
    on: {
      "click": function($event) {
        _vm.showAddReasonInput = !_vm.showAddReasonInput
      }
    }
  }, [_vm._v("+ Add")])], 1), _vm._v(" "), (_vm.showAddReasonInput) ? _c('div', {
    staticClass: "mt-2 d-flex align-items-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "placeholder": "Enter new delay reason"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addNewDelayReason($event)
      }
    },
    model: {
      value: (_vm.newDelayReason),
      callback: function($$v) {
        _vm.newDelayReason = $$v
      },
      expression: "newDelayReason"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.addDelayReasonLoading || !_vm.newDelayReason.trim()
    },
    on: {
      "click": _vm.addNewDelayReason
    }
  }, [(_vm.addDelayReasonLoading) ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n              Save\n            ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.showAddReasonInput = false;
        _vm.newDelayReason = ''
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e(), _vm._v(" "), (_vm.cbApproval.delay_reason_error) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.cbApproval.delay_reason_error) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Delay Remark"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Enter remark (optional)"
    },
    model: {
      value: (_vm.cbApproval.delay_reason_remark),
      callback: function($$v) {
        _vm.$set(_vm.cbApproval, "delay_reason_remark", $$v)
      },
      expression: "cbApproval.delay_reason_remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "disabled": _vm.cbApproval.isSubmitting
    },
    on: {
      "click": function($event) {
        _vm.showCBApprovalModal = false
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "disabled": _vm.cbApproval.isSubmitting
    },
    on: {
      "click": _vm.sendCBApprovalRequest
    }
  }, [(_vm.cbApproval.isSubmitting) ? _c('span', [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n              Sending...\n            ")], 1) : _c('span', [_vm._v("Send Approval Request")])])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "my-modal-confirm",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "id": "modal-multi-1",
      "size": "lg",
      "title": "Confirmation"
    }
  }, [_c('h5', {
    staticClass: "my-2 error"
  }, [_vm._v("Confirmation..! ")]), _vm._v(" "), (
    ((_vm.actionType == 'SPLIT' && _vm.ffAlreadyInAssignment) || (_vm.actionType == 'CHANGE' && !_vm.ffAlreadyInAssignment)) &&
    ((_vm.ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && _vm.isMultiBooking))


  ) ? _c('div', [(
    ((_vm.actionType == 'SPLIT' && _vm.ffAlreadyInAssignment) || (_vm.actionType == 'CHANGE' && !_vm.ffAlreadyInAssignment)) &&
    ((_vm.ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && _vm.isMultiBooking)) &&
    (_vm.ffExoprtDetail.transportType == 'Export') &&
    _vm.ffExoprtDetail.shipmentType == 1 &&
    _vm.ffExoprtDetail.containerInfo == 'fcl'
  ) ? _c('label', {
    attrs: {
      "for": "validBookingNo"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ffExoprtDetail.transportType == "Import" ? " BL No." : " Booking No.")), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]), _vm._v(" "), (
    ((_vm.ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && _vm.isMultiBooking)) &&
    _vm.ffExoprtDetail.transportType == 'Export' &&
    _vm.ffExoprtDetail.shipmentType == 1 &&
    _vm.ffExoprtDetail.containerInfo == 'fcl' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
    _vm.$sessionsStorage.get('designation') == 'Admin'
  ) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.checkAllCBBTN();
        _vm.getConsoleBooking();
      }
    },
    model: {
      value: (_vm.checkAllCBVal),
      callback: function($$v) {
        _vm.checkAllCBVal = $$v
      },
      expression: "checkAllCBVal"
    }
  }, [_vm._v(_vm._s(_vm.checkAllCBVal ? "Selected" : "Un-Selected"))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (

    ((_vm.ffExoprtDetail.changedRequestJobType.indexOf('FF') >= 0 && _vm.isMultiBooking)) &&
    // (ffExoprtDetail.transportType == 'Export') 
    (_vm.ffExoprtDetail.transportType == 'Export' || _vm.ffExoprtDetail.transportType == 'Import' || _vm.ffExoprtDetail.transportType == 'IMPORT') &&
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'fcl'
  ) ? _c('multi-select', {
    attrs: {
      "options": _vm.ConsoleBookingList,
      "selected-options": _vm.items,
      "placeholder": "Select Booking Number",
      "multiple": true
    },
    on: {
      "select": _vm.SelectmultiConsoleBooking
    },
    model: {
      value: (_vm.ffExoprtDetail.validmultiBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "validmultiBookingNo", $$v)
      },
      expression: "ffExoprtDetail.validmultiBookingNo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.validmultiBookingNoErr || !_vm.validBookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExoprtDetail.validmultiBookingNoErr || "Booking No Required"))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actionType == 'CHANGE') ? _c('div', [_vm._v("\n        Assignment No. will change as per additional JOB selected..!\n      ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModalConfirm
    }
  }, [_vm._v("Close & Cancel")]), _vm._v(" "), (_vm.actionType != '') ? _c('b-button', {
    staticClass: "mt-4 pull-right",
    attrs: {
      "disabled": _vm.actionType == 'CHANGE' &&
        !_vm.ffAlreadyInAssignment &&
        _vm.ffExoprtDetail.changedRequestJobType.includes('FF') &&
        _vm.ffExoprtDetail.containerInfo === 'fcl' &&
        _vm.ffExoprtDetail.shipmentType === '1' &&
        (
          _vm.ffExoprtDetail.transportType === 'Export' ||
          _vm.ffExoprtDetail.transportType === 'Import' ||
          _vm.ffExoprtDetail.transportType === 'IMPORT'
        ) &&
        _vm.ffExoprtDetail.validmultiBookingNo.length <= 0,
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.mergeSplitAssignment
    }
  }, [_vm._v(_vm._s(_vm.actionType))]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "location-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "id": "modal-multi-2",
      "size": "lg",
      "title": 'Change Location Of  : ' + _vm.seriesNumber
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.options1,
      "option-value": "pickupLocation",
      "option-text": "pickupLocation",
      "placeholder": "select item"
    },
    model: {
      value: (_vm.objectItem),
      callback: function($$v) {
        _vm.objectItem = $$v
      },
      expression: "objectItem"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModalLoc
    }
  }, [_vm._v("Close & Cancel")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4 ml-auto",
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.changeLocation
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "assignmentCLose-confirm",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "id": "modal-multi-1",
      "size": "lg",
      "title": "Confirmation"
    }
  }, [_c('div', [_vm._v("Are you sure to close Assignment Billing ?")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideCloseBillingModalConfirm
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.actionType != '') ? _c('b-button', {
    staticClass: "mt-4 pull-right",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.closeBillOk('Yes')
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-Add-Open",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Enter Container Type and Volumes'
    }
  }, [(_vm.ffExoprtDetail.clientType == '2') ? _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "client-input-section p-3 border rounded shadow-sm",
    staticStyle: {
      "background": "#fdfdfd",
      "border-left": "5px solid #27ae60 !important"
    }
  }, [_c('h6', {
    staticClass: "mb-3 text-success font-weight-bold"
  }, [_c('i', {
    staticClass: "fa fa-user-plus mr-1"
  }), _vm._v(" Convert Lead to Client - Details\n            ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("Client Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "placeholder": "Enter Client Name",
      "disabled": true
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientName", $$v)
      },
      expression: "ffExoprtDetail.newClientName"
    }
  }), _vm._v(" "), (_vm.newClientNameError) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.newClientNameError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("Client Email "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "placeholder": "Enter Client Email"
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientEmail),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientEmail", $$v)
      },
      expression: "ffExoprtDetail.newClientEmail"
    }
  }), _vm._v(" "), (_vm.newClientEmailError) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.newClientEmailError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("Contact No "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "placeholder": "Enter Contact No",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientPhoneNumber", $$v)
      },
      expression: "ffExoprtDetail.newClientPhoneNumber"
    }
  }), _vm._v(" "), (_vm.newClientPhoneNumberError) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.newClientPhoneNumberError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("PAN No (AAAAA1234A) "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "placeholder": "Enter PAN",
      "formatter": _vm.capitalizeAll
    },
    on: {
      "keyup": _vm.validateNewClientPan
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientPan),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientPan", $$v)
      },
      expression: "ffExoprtDetail.newClientPan"
    }
  }), _vm._v(" "), (_vm.newClientPanError) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.newClientPanError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("TAN No (AAAA12345A) "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-checkbox', {
    staticClass: "ml-2 d-inline-block small",
    on: {
      "change": _vm.onTanNotApplicableChange
    },
    model: {
      value: (_vm.ffExoprtDetail.isTanNotApplicable),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "isTanNotApplicable", $$v)
      },
      expression: "ffExoprtDetail.isTanNotApplicable"
    }
  }, [_vm._v("\n                  Not Applicable\n                ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "placeholder": "Enter TAN",
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.ffExoprtDetail.isTanNotApplicable
    },
    on: {
      "keyup": _vm.validateNewClientTan
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientTan),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientTan", $$v)
      },
      expression: "ffExoprtDetail.newClientTan"
    }
  }), _vm._v(" "), (_vm.newClientTanError) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.newClientTanError))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "small font-weight-bold"
  }, [_vm._v("Client Address "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "size": "sm",
      "rows": "2",
      "placeholder": "Enter Client Address"
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientAddress),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientAddress", $$v)
      },
      expression: "ffExoprtDetail.newClientAddress"
    }
  }), _vm._v(" "), (_vm.newClientAddressError) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.newClientAddressError))]) : _vm._e()], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == 1) ? _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                  Container Type\n                ")]) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == 1) ? _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                  Total Container\n                ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Tues Val")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                  Actions\n                  "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addLeadCont(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1)]), _vm._v(" "), _vm._l((_vm.ContainerVolumesArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == 1) ? _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllContainerTypeList'],
        "option-value": "containerTypeId",
        "option-text": "containerType",
        "placeholder": "Select Container Type"
      },
      model: {
        value: (item.fk_cont_type_id),
        callback: function($$v) {
          _vm.$set(item, "fk_cont_type_id", $$v)
        },
        expression: "item.fk_cont_type_id"
      }
    }), _vm._v(" "), (item.fk_cont_type_id_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.fk_cont_type_id_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == 1) ? _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Total COntainer"
      },
      model: {
        value: (item.tot_continer),
        callback: function($$v) {
          _vm.$set(item, "tot_continer", $$v)
        },
        expression: "item.tot_continer"
      }
    }), _vm._v(" "), (item.tot_continer_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.tot_continer_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter TUES Volume"
      },
      model: {
        value: (item.continer_tues_val),
        callback: function($$v) {
          _vm.$set(item, "continer_tues_val", $$v)
        },
        expression: "item.continer_tues_val"
      }
    }), _vm._v(" "), (item.continer_tues_val_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.continer_tues_val_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-textarea', {
      attrs: {
        "rows": "2",
        "formatter": _vm.capitalizeAll,
        "type": "text",
        "placeholder": "Enter Remark"
      },
      model: {
        value: (item.continer_remark),
        callback: function($$v) {
          _vm.$set(item, "continer_remark", $$v)
        },
        expression: "item.continer_remark"
      }
    })], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeLeadCont(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  })], 2)])]), _vm._v(" "), _c('b-col', {
    staticClass: "mx-auto",
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Client Document"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('ClientFileUploader', {
    style: ('height: 80px; background: darkgray; width: 100%'),
    attrs: {
      "documentName": 'Client_Multiple_Doc-',
      "otherDocName": 'Client_Multiple_Doc-',
      "folderName": 'CLIENTKYCDOC',
      "accept": '*',
      "assign_no": 'CLIENTKYCDOC',
      "multiple": true,
      "state": Boolean(_vm.client_doc),
      "fileAllModuleId": '0'
    },
    model: {
      value: (_vm.client_doc),
      callback: function($$v) {
        _vm.client_doc = $$v
      },
      expression: "client_doc"
    }
  }), _vm._v(" "), (_vm.client_doc_err) ? _c('span', {
    staticClass: "error small"
  }, [_vm._v(_vm._s(_vm.client_doc_err))]) : _vm._e()], 1), _vm._v(" "), (_vm.client_doc) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.client_doc) ? _c('div', _vm._l((_vm.client_doc.split(',')), function(item1, index) {
    return _c('b-button', {
      key: index,
      staticClass: "mb-1",
      staticStyle: {
        "margin-left": "2px",
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          item1 ? _vm.PrintValidity_Doc(item1) : ''
        }
      }
    }, [_vm._v(_vm._s(item1 ? "PDF" + (parseInt(index) + 1) : ""))])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.ContainerVolumesArr.length > 0) ? _c('b-button', {
    staticClass: "mt-3 sm",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitContainer
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3 sm",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddFF
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addClient",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.updateClientNew
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "sendExecution",
    attrs: {
      "md-title": _vm.alert.title,
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendExecutionTeam
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1695cf2d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/salesExecutionAll.vue
// module id = 2413
// module chunks = 0